import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { setDemoSession } from '../lib/session';

// Showroom Manager entry: no-login. Fetches an isolated demo-manager session,
// stores it as the normal auth session, remembers the showroom return URL for
// Back, and lands DIRECTLY in Command Center. Reuses the standard auth boot.
export default function DemoManagerEntry() {
    const { t } = useTranslation();

    useEffect(() => {
        const API = (typeof window !== 'undefined' ? window.location.origin : '');
        const params = new URLSearchParams(window.location.search);
        const returnUrl = params.get('return_url') || '';
        (async () => {
            try {
                const qs = returnUrl ? `?return_url=${encodeURIComponent(returnUrl)}` : '';
                const res = await fetch(`${API}/api/demo-manager/session${qs}`);
                const d = await res.json();
                if (!res.ok || !d.access_token) throw new Error('session');
                setDemoSession(d.access_token, d.user || {});
                // Showroom demo isolation: mark this tab as a demo manager session so the
                // Daily-Review WelcomeRedirectGate never intercepts /command-center and sends
                // the synthetic manager to /welcome. Affects ONLY this demo tab.
                sessionStorage.setItem('yulontap_demo_mode', '1');
                // This is the PROPERTY demo: drop any hotel/automotive vertical
                // flag left in this tab so the demo shell shows PROPERTY branding.
                sessionStorage.removeItem('yulontap_hotel_demo');
                sessionStorage.removeItem('yulontap_auto_demo');
                // Force dark/night for the demo Command Center (no white flash).
                try { localStorage.setItem('yulontap-theme-preference', 'dark'); } catch (_e) { /* ignore */ }
                document.documentElement.classList.add('dark');
                if (d.return_url) sessionStorage.setItem('yulontap_demo_return', d.return_url);
                else sessionStorage.removeItem('yulontap_demo_return');
                window.location.replace('/command-center');
            } catch (e) {
                sessionStorage.setItem('yulontap_demo_mode', '1');
                window.location.replace('/command-center');
            }
        })();
    }, []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-slate-200"
            data-testid="demo-manager-entry">
            <Loader2 className="w-8 h-8 animate-spin text-emerald-400" />
            <p className="text-sm">{t('demo.enteringManager', 'Opening Command Center…')}</p>
        </div>
    );
}
